"use client"

import { useState } from "react"
import "./SoftwareFaq.css"

const faqData = [
  {
    question: "What is Software Development?",
    answer:
      "Software development is the process of designing, creating, and testing computer programs and applications. This involves writing code, debugging, and making improvements based on user feedback.",
  },
  {
    question: "What is a Software Agency?",
    answer:
      "A software agency, also known as a software development agency or software consulting firm, is a company that specializes in creating custom software solutions for clients. They typically have a team of developers, designers, and project managers who work collaboratively to deliver quality software products.",
  },
  {
    question: "How much does custom software development cost?",
    answer:
      "The cost of custom software development varies depending on the complexity of the project, the size of the team, and the level of expertise required. However, at Imaginary Cloud, it typically ranges from $24,000 to $180,000.  Check Imaginary Cloud’s pricing overview here.",
  },
  {
    question:
      "Which programming languages are best for web application development?",
    answer:
      "Some popular programming languages for web application development include JavaScript, Python and Ruby on Rails. The best language depends on the specific needs of your project and the expertise of your development team. At Imaginary Cloud, we prioritize using open-source technologies as they often have large and active communities of developers and users. An open-source tech stack offers up to 60% savings, customization options, security, support from community, and future-proofs for your software development project.",
  },
  {
    question: "What are reliable software development firms for startups?",
    answer:
      "Some reliable software development firms for startups include Imaginary Cloud, Inventive Works, Origami Studios, One Beyond, Accelerance, GoodCore Software, Light IT Global, Rootstrap, and Osedea. These companies have established themselves as leaders in the industry and are trusted by clients worldwide. To choose the best software development company for your startup, it's important to consider factors such as project requirements and goals, experience and expertise in your industry, past project portfolio, online reviews and ratings, communication channels, development process and methodology, project timeline and estimated budget, technical skills, and knowledge of relevant technologies, as well as security measures and post-project support and maintenance services.Take a look at this checklist before partnering up with a software development agency.",
  },
  {
    question: "What is the typical timeline for developing a mobile app?",
    answer:
      "The timeline for developing a mobile app varies depending on the complexity - from website and MVP development, to web app solutions -, and the size of the team. However, it typically takes anywhere from 2 to 6 months or more to develop a mobile app from start to finish.",
  },
  {
    question:
      "What are the key steps involved in the software development life cycle?",
    answer:
      "The software development life cycle typically involves 6 stages: planning, analysis, design, development, testing, and maintenance. Each stage involves different tasks and activities to ensure the software is built according to specifications and meets user needs.",
  },
  {
    question:
      "How can i find experienced software developers for my project?",
    answer:
      "1. Research and define your project requirements and expectations, such as the type of app you want to build, your existing roles and tech stack, and your budget.2. Look for software development companies that have experience in your industry or have worked on projects similar to yours. Check their portfolio and website to get a feel for their capabilities, and assess the number of technologies they use and their expertise in those areas.3. Check out reliable client review sites like Clutch, Techreviewer, and Google, and look for both positive and negative reviews to get a well-rounded understanding of the companies you're considering. Consider reaching out to your network for referrals or suggestions.4. Pay attention to the company's communication and development processes and the tools they use, such as online chats like Slack or project management tools like Jira. Transparency is key, and a company that values retrospective meetings and is committed to continuously improving their development process is a good sign.5. Check for any red flags, such as companies with poor-quality websites, generic testimonials, or vague portfolios. Also, avoid companies that are much larger or cheaper than your company, or companies that claim to have all-knowing experts with extreme tech stacks.By keeping these factors in mind, you can narrow down your search and find experienced software developers who are the right fit for your project.By keeping these factors in mind, you can narrow down your search and find experienced software developers who are the right fit for your project.",
  },
  {
    question:
      "What are the Agile development methodology and its benefits?",
    answer:
      "The agile development methodology is an approach to the software development process that prioritizes collaboration and flexibility. It involves breaking down a project into smaller, iterative stages and making frequent changes based on user feedback. The benefits of this approach include faster development times, increased customer satisfaction, and improved project management.Here are the 18 best Agile practices to use in your Software Development Life Cycle..",
  },
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section234">
          <h1 className="main-title1">EVERYTHING YOU NEED TO KNOW ABOUT OUR</h1>
          <h2 className="sub-title">SOFTWARE DEVELOPMENT SERVICE</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
